export enum CardinalLoadMode {
  V1_ONLY = "V1_ONLY",
  V2_WITH_FALLBACK = "V2_WITH_FALLBACK",
  V2_ONLY = "V2_ONLY",
}
